<template>
  <div class="sidearm-mm-gameday-preview flex flex-align-center h-100">
    <div class="col-1-of-8"></div>

    <div class="col-3-of-8">
      <h2 v-if="this.round.title" class="type-hero">
        {{ this.round.title }}
      </h2>

      <p v-if="game.story && game.story.headline" class="type-paragraph-large">
        {{ this.game.story.headline }}
      </p>
      <p v-else-if="!game.opponent" class="type-paragraph-large">
        Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
        {{ this.$root.data.school.name }} will compete in the
        {{ round.title }}{{
          game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
        }}.
      </p>
      <p v-else class="type-paragraph-large">
        Gameday: {{this.$root.data.team.seed ? "No. " + this.$root.data.team.seed : ""}}
        {{ this.$root.data.school.name }} will square off in the
        {{ round.title }} against{{
          game.opponent.seed ? " No. " + game.opponent.seed : ""
        }}
        {{ this.$root.shorten_name(game.opponent.title)
        }}{{
          game.tbd ? "" : " on " + moment(game.date).format("MMM D, YYYY")
        }}.
      </p>

      <div
        v-if="game"
        class="sidearm-mm-gameday-preview__info-table border-primary-a mt-3 mb-2"
      >
        <div class="flex border-primary-b">
          <div class="px-2 py-1 flex-item-1 border-primary-r">
            {{ moment(game.date).format("MMM D, YYYY") }}
          </div>
          <div class="px-2 py-1 flex-item-auto">
            {{ game.tbd ? "TBD" : moment(game.date).format("h:mm A") }}
          </div>
        </div>
        <div v-if="game.location" class="py-1 px-2 text-bold">
          {{ game.location }}
        </div>
      </div>

      <game-media :game="game"></game-media>
    </div>

    <div class="col-1-of-8"></div>

    <div
      class="sidearm-mm-gameday-preview__bracket col-3-of-8 flex-align-self-stretch bg-white flex flex-align-center"
    >
      <div class="w-100">
        <matchup-bracket-desktop
          :round="round"
          :size="120"
          theme="light"
          show-seeds
        />
      </div>
    </div>
  </div>
</template>

<script>
import MatchupBracketDesktop from "@/components/MatchupBracketDesktop";
import GameMedia from "@/components/GameMedia";

export default {
  components: {
    MatchupBracketDesktop,
    GameMedia
  },
  props: {
    round: { type: [Object, null], required: true }
  },

  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    game_media_gamefiles() {
      if (this.game && this.game.media && this.game.media.gamefiles) {
        return this.game.media.gamefiles.filter(x => x.title && x.url);
      }
      return [];
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.#{$prefix}-gameday-preview {
  &__bracket {
    padding-left: grid_percent(120);
  }
}
</style>
